module.exports = __webpack_public_path__ + "js/1.759e6c3a.worker.js"